import { render, staticRenderFns } from "./Assistencia.vue?vue&type=template&id=4d7dabde&scoped=true"
import script from "./Assistencia.vue?vue&type=script&lang=ts"
export * from "./Assistencia.vue?vue&type=script&lang=ts"
import style0 from "./Assistencia.vue?vue&type=style&index=0&id=4d7dabde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7dabde",
  null
  
)

export default component.exports